import React, { useContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { AuthContext } from "../../components/user/BCPAuthProvider";

export default function CMSAdmin() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const go = async () => {
      try {
        await hasEditorAccess(authContext, true);
      } catch (err) {
        navigate("/home");
        setLoading(false);

        return;
      }

      setLoading(false);
    };
    go();
    // eslint-disable-next-line
  }, []);

  if (loading) return <ModalLoadingFull />;

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <Grid container sx={{ gap: 2 }}>
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                boxShadow: 1,
                backgroundColor: "background.secondary",
              }}
            >
              <Typography variant="h3">CMS Dashboard</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                boxShadow: 1,
                backgroundColor: "background.secondary",
              }}
            >
              <Grid container sx={{ gap: 2 }}>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    href="/cms/my-posts"
                  >
                    My posts
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    href="/cms/my-pages"
                  >
                    My pages
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    href="/cms/post"
                  >
                    New Post / Page
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    href="/cms/tag-list"
                  >
                    Tag / Category List
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export async function hasEditorAccess(authContext, notify) {
  var err;

  if (
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.isEditor === true
  ) {
    return true;
  }

  err = new Error("You do not have access to this function");
  if (!!notify) postNotification("warning", err);

  if (err) {
    throw err;
  }
  return false;
}
